import {
  Button,
  DatePicker,
  Modal,
  Select,
  Skeleton,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { formatDateAndTime, trimString } from "../../../Utils";
import dayjs from "dayjs";
import ReportDrawer from "../../../Common/ReportDrawer";
import { AiOutlineSearch } from "react-icons/ai";
import Content from "../../../Common/ReceiptContent";
import { setselectedTab } from "../../../Store/B2bslice";
import { useDispatch } from "react-redux";
import CommonInput from "../../../Common/CommonInput";
import CommonPagination from "../../../Common/Pagination";
import {
  Dmt2getRefund,
  getDmt2Report,
  resendOtpDmt2,
} from "../../../ApiServices/Apifun";
import VerifyModal from "../../../Common/VerifyModal";
import { Globalendpoints } from "../../../ApiServices/global";
import DmtPayModal2 from "../DMT2/DmtPayModal2";
import useOtpHook from "../../../Hooks/useOtpHook";

const Dmt2Report = () => {
  const dispatch = useDispatch();
  const [dataSource, setDataSource] = useState([]);
  const [current, setCurrent] = useState(1);
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [searchcolumn, setSearchColumn] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [result, setResult] = useState({ data: null, transaction_id: null });
  const [searchOptions, setSearchOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { handleChange, handleKeyUp, pin, inputRefs } = useOtpHook(4);
  const [btnLoading, setBtnLoading] = useState(false);
  const [record, setRecord] = useState({});
  const ReportColumn = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      render: (text) => (
        <p className="font-medium w-[150px]">{formatDateAndTime(text)}</p>
      ),
    },
    {
      title: "Transaction Id",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (text) => {
        return (
          <>
            <p className=" font-medium ">{text}</p>
          </>
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text} Rs.
        </p>
      ),
    },
    {
      title: "Beneficiary Name",
      dataIndex: "beneficiary_name",
      key: "beneficiary_name",
      render: (text) => (
        <p className="font-medium w-[130px]  px-3">
          {text ? text : "-"}
        </p>
      ),
    },
    {
      title: "account No.",
      dataIndex: "account_no",
      key: "account_no",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[130px]  overflow-y-scroll">
              {text ? text : "-"}
            </p>
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        return (
          <div>
            {text === "0" ? (
              <Tag color="yellow"> Pending</Tag>
            ) : text === "1" ? (
              <Tag color="green">Success</Tag>
            ) : text === "2" ? (
              <Tag color="red">Failed</Tag>
            ) : text === "3" ? (
              <Button
                size="small"
                className="bg-primary text-white"
                onClick={() => {
                  setIsOpen(true);
                  setRecord(record);
                  handleResendOTP(record);
                }}
              >
                Proceed to Refund
              </Button>
            ) : (
              <Tag color="orange">Refunded</Tag>
            )}
          </div>
        );
      },
    },
    {
      title: "IFSC",
      dataIndex: "ifsc_code",
      key: "ifsc_code",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[100px] ">
              {text ? text : "-"}
            </p>
          </>
        );
      },
    },
    {
      title: "Bank Name",
      dataIndex: "bank_name",
      key: "bank_name",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[150px] overflow-y-scroll">
              {text ? text : "-"}
            </p>
          </>
        );
      },
    },
    {
      title: "Transfer Mode",
      dataIndex: "transfer_mode",
      key: "transfer_mode",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[100px]  ">
              {text ? text : "-"}
            </p>
          </>
        );
      },
    },
    {
      title: "Surcharge",
      dataIndex: "surcharge",
      key: "surcharge",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[100px]  ">
              {text ? text + " " + "Rs." : "-"}
            </p>
          </>
        );
      },
    },
    {
      title: "RRN",
      dataIndex: "rrn",
      key: "rrn",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[120px] overflow-y-scroll">
              {text ? text : "-"}
            </p>
          </>
        );
      },
    },
    {
      title: "Remarks",
      dataIndex: "remark",
      key: "remark",
      render: (text) => {
        return (
          <>
            <Tooltip title={text}>
              <p className="font-medium w-[200px]  px-3 overflow-y-scroll">
                {text ? trimString(text) : "-"}
              </p>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const getReport = (
    search_keyword = searchKeyword,
    search_column = searchcolumn,
    from_date = fromDate,
    to_date = toDate
  ) => {
    setLoading(true);
    const payload = {
      per_page: pageSize,
      page_no: current,
      search_keyword: search_keyword,
      search_column: search_column,
      from_date: from_date,
      to_date: to_date,
    };
    const formdata = new FormData();
    Object.keys(payload).map((key) => formdata.append(key, payload[key]));
    getDmt2Report(formdata)
      .then((res) => {
        setDataSource(res.data);
        // setCurrent(Number(res.page_no));
        setTotalPages(res.total);
        setSearchOptions(
          res?.filter_column_name?.map((i, index) => {
            return {
              label: i,
              value: res.filter_column_key[index],
            };
          })
        );
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getReport();
  }, [current, pageSize]);

  useEffect(() => {
    dispatch(setselectedTab("11.18"));
  }, []);

  const handleResendOTP = (val) => {
    console.log(val, "valuable record");
    const formdata = new FormData();
    formdata.append("transaction_id", val.transaction_id);
    resendOtpDmt2(formdata)
      .then((res) => {
        if (res.status) {
          setStateResp(res.data.stateresp);

          // setHide(true);
          // setOpenVerifyModal(true);
        }
      })
      .catch((err) => console.log(err));
  };
  const handleVerify = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("otp", pin.join(""));
    formdata.append("transaction_id", record.transaction_id);

    Dmt2getRefund(formdata)
      .then((res) => {
        if (res?.status) {
          dispatchtoast("Refund Initiated Successfully", false);
          setResponse(res);
          setHide(false);
          setShowSuccess(true);
          setBtnLoading(false);
        } else {
          dispatchtoast("Something went wrong", true);
          setBtnLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setBtnLoading(false);
      })
      .finally(() => {
        setBtnLoading(false);
        setIsOpen(false);
      });
  };

  return (
    <>
      <div className="">
        <div className="prepaid  animate-fade-in w-full  bg-white shadow-normal  rounded-xl p-4">
          <div className="flex justify-between items-center">
            <p className="font-bold text-[15px] mb-2">DMT2 Report</p>
            <p
              onClick={() => {
                getReport("", "", "", "");
                setSearchKeyWord("");
                setSearchColumn(null);
                setFromDate("");
                setToDate("");
              }}
              className="font-medium text-xs cursor-pointer bg-bsred hover:bg-red-600 text-white px-2 py-1 rounded-md text-[15px] mb-2"
            >
              Clear Filter
            </p>
          </div>
          <div className="selectionFields grid grid-cols-1 md:grid-cols-3 gap-4 place-items-center ">
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                Select Search Type
              </p>
              <Select
                placeholder="Select search type"
                value={searchcolumn}
                onChange={(val) => setSearchColumn(val)}
                className="w-full mt-2"
                options={searchOptions}
              />
            </div>
            <div className="w-full">
              <p className={`required text-textGray `}>Keyword</p>
              {searchcolumn === "dmt.created_at" ? (
                <DatePicker
                  // value={dayjs("2023-09-07","YYYY-MM-DD")}
                  popupClassName="bottom-calendar"
                  allowClear
                  // value={searchKeyword}
                  className="w-full datepicker mt-4"
                  onChange={(val) =>
                    setSearchKeyWord(dayjs(val).format("YYYY-MM-DD"))
                  }
                  placement="bottomLeft"
                  placeholder="Search"
                />
              ) : (
                <CommonInput
                  placeholder="Seacrh"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyWord(e.target.value)}
                  className="outline-none text-xs border mt-4 w-full  border-gray-200 focus:border-primary   px-2 "
                />
              )}
            </div>
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                From Date - To Date
              </p>
              <DatePicker.RangePicker
                allowClear
                onChange={(val) => {
                  setFromDate(val ? dayjs(val[0]).format("YYYY-MM-DD") : "");
                  setToDate(val ? dayjs(val[1]).format("YYYY-MM-DD") : "");
                }}
                className="w-full mt-2"
              />
            </div>{" "}
          </div>
          <div className="w-full flex justify-end items-center mt-3">
            <Button
              // disabled=
              onClick={() => getReport()}
              style={{ color: "white" }}
              className=" font-semibold flex justify-between gap-2 items-center hover:bg-primaryhover bg-primary border-none"
            >
              <AiOutlineSearch />
              <p>Search</p>
            </Button>
          </div>
        </div>
      </div>
      <div>
        <div className="mt-4">
          <Spin spinning={loading}>
            <Table
              className="history-table animate-fade-in max-h-[500px] overflow-x-auto text-white rounded-lg"
              columns={ReportColumn}
              pagination={false}
              onRow={(record, rowIndex) => {
                const isClickable = record.status !== "3";

                return {
                  onClick: isClickable
                    ? () => {
                        setResult({
                          data: {
                            Date: record.Date,
                            Name: record.beneficiary_name,
                            Account: record.account_no,
                            IFSC: record.ifsc_code,
                            "Bank Name": record.bank_name,
                            "Transfer Mode": record.transfer_mode,
                            Amount: record.amount,
                            Surcharge: record.surcharge,
                            RRN: record.rrn,
                            Remark: record.remark,
                          },
                          transaction_id: record.transaction_id,
                        });
                        setOpenReceiptDrawer(true);
                      }
                    : undefined,
                  className: isClickable
                    ? "cursor-pointer text-[12px]"
                    : "text-[12px]",
                };
              }}
              dataSource={dataSource}
            />

            <div className="mt-2 mb-8 flex justify-end items-center">
              <CommonPagination
                totalPages={totalPages}
                current={current}
                pageSize={pageSize}
                setCurrent={setCurrent}
                setPageSize={setPageSize}
              />
            </div>
          </Spin>
        </div>
      </div>

      {isOpen && (
        <Modal
          title="Verify OTP"
          footer={null}
          className="shadow-normal"
          width={300}
          maskClosable={false}
          open={isOpen}
          onCancel={() => setIsOpen(false)}
        >
          <div className="  rounded-3xl shadow-normal bg-white ">
            <>
              <div className="header flex flex-col justify-center items-center">
                <p className="text-[15px] mt-3 text-gray-500">Enter OTP</p>
              </div>
              <div className=" mt-5 flex justify-center items-center">
                {[1, 2, 3, 4].map((i, index) => {
                  return (
                    <>
                      <input
                        key={index}
                        ref={inputRefs[index]}
                        type="text"
                        maxLength={1}
                        className="w-[15px] otpinput xs:w-[35px] sm:w-[35px] md:w-[40px] text-bsblackrgb rounded-md bg-gray-300 h-8  mx-1 border-none focus:outline-none focus:border-none text-center"
                        value={pin[index]}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyUp={(e) => handleKeyUp(index, e)}
                      />
                    </>
                  );
                })}
              </div>
              <Button
                loading={btnLoading}
                onClick={() => pin.length === 4 && handleVerify()}
                className={`SignInBtn w-full ${
                  pin.length === 4 ? "cursor-pointer" : "cursor-not-allowed"
                }  mt-4 ${
                  pin.length === 4 ? "bg-primary" : "bg-bsgray"
                }  flex justify-center border-none items-center h-12 mt-10 rounded-full text-white text-[12px] font-bold`}
              >
                <p>Refund Initiated</p>
              </Button>
            </>
          </div>
        </Modal>
      )}

      {openReceiptDrawer && (
        <ReportDrawer
          title={"DMT 2 Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          content={<Content data={result} />}
        />
      )}
    </>
  );
};

export default Dmt2Report;